import { render, staticRenderFns } from "./MessagePush.vue?vue&type=template&id=3aa5da28&scoped=true&"
import script from "./MessagePush.vue?vue&type=script&lang=js&"
export * from "./MessagePush.vue?vue&type=script&lang=js&"
import style0 from "./MessagePush.vue?vue&type=style&index=0&id=3aa5da28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa5da28",
  null
  
)

export default component.exports